module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "als"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmhT"
  }, [_vm._v("Also by David Gessner")]), _vm._v(" "), _c('div', {
    staticClass: "ctag1"
  }, [_c('i', [_vm._v("My Green Manifesto")]), _vm._v(" "), _c('br'), _c('i', [_vm._v("The Prophet of Dry Hill")]), _vm._v(" "), _c('br'), _c('i', [_vm._v("Return of the Osprey")]), _vm._v(" "), _c('br'), _c('i', [_vm._v("Sick of Nature")]), _vm._v(" "), _c('br'), _c('i', [_vm._v("Soaring with Fidel")]), _vm._v(" "), _c('br'), _c('i', [_vm._v("Under the Devil’s Thumb")]), _vm._v(" "), _c('br'), _c('i', [_vm._v("A Wild, Rank Place")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88e73876","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/davi_9781571318398_oeb_als_r1.vue
// module id = 66
// module chunks = 0